import React from 'react';
import { Container } from 'react-bootstrap';

const Terms: React.FC = () => {
  return (
    <Container className="py-5">
      <h2>Terms of Service</h2>
      <div className="mt-4">
        <h3>1. Acceptance of Terms</h3>
        <p>By accessing and using CryptoSwappie, you agree to be bound by these Terms of Service.</p>

        <h3>2. Service Description</h3>
        <p>CryptoSwappie provides a cryptocurrency exchange platform that allows users to swap various cryptocurrencies.</p>

        <h3>3. User Obligations</h3>
        <p>Users must ensure all information provided is accurate and comply with applicable laws and regulations.</p>

        <h3>4. Exchange Rates and Fees</h3>
        <p>Exchange rates are determined by market conditions. We reserve the right to modify our fee structure.</p>

        <h3>5. Transaction Processing</h3>
        <p>Transaction times may vary based on network conditions. We are not responsible for network delays.</p>

        <h3>6. Privacy and Security</h3>
        <p>We implement security measures to protect your transactions but cannot guarantee absolute security.</p>

        <h3>7. Prohibited Activities</h3>
        <p>Users must not engage in illegal activities or attempt to manipulate the platform.</p>

        <h3>8. Limitation of Liability</h3>
        <p>CryptoSwappie is not liable for any losses incurred during cryptocurrency exchanges.</p>

        <h3>9. Modifications</h3>
        <p>We reserve the right to modify these terms at any time. Continued use constitutes acceptance of changes.</p>

        <h3>10. Contact Information</h3>
        <p>For questions about these terms, please contact our support team.</p>
      </div>
    </Container>
  );
};

export default Terms;